/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'app.bsky.contact.verifyPhone'

export { $nsid }

/** Verifies control over a phone number with a code received via SMS and starts a contact import session. Requires authentication. */
const main = l.procedure(
  $nsid,
  l.params(),
  l.jsonPayload({ phone: l.string(), code: l.string() }),
  l.jsonPayload({ token: l.string() }),
  [
    'RateLimitExceeded',
    'InvalidDid',
    'InvalidPhone',
    'InvalidCode',
    'InternalError',
  ],
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Input<B = l.BinaryData> = l.InferMethodInput<typeof main, B>
export type $InputBody<B = l.BinaryData> = l.InferMethodInputBody<
  typeof main,
  B
>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $input = main.input,
  $output = main.output
